<div class="lightswitch" [class.on]="status" (click)="toggle()">
    <ng-container *ngIf="labelLeft">
        <div class="label left">{{ labelLeft }}</div>
    </ng-container>
    <div class="switch"></div>
    <ng-container *ngIf="labelRight">
        <div class="label right">{{ labelRight }}</div>
    </ng-container>
</div>